// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Added to cart!`
};

const el_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Προστέθηκε στο καλάθι!`
};

const ru_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `Добавлено в корзину!`
};

const he_added_to_cart = /** @type {(inputs: {}) => string} */ () => {
	return `נוסף לסל!`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const added_to_cart = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.added_to_cart(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("added_to_cart", locale)
	if (locale === "en") return en_added_to_cart(inputs)
	if (locale === "el") return el_added_to_cart(inputs)
	if (locale === "ru") return ru_added_to_cart(inputs)
	if (locale === "he") return he_added_to_cart(inputs)
	return "added_to_cart"
};